import { EMPTY_ARRAY } from '@e-socna/empty';

import { Wizard } from '../../components/Wizard';
import { Loading } from '../../components/Loading';

import { useInitialValuesFactory } from './hooks/useInitialValuesFactory.hook';
import { useActorSteps } from './hooks/useSteps.hook';
import { BaseRoleFlagsProvider } from './contexts/base-role-flags.context';
import { NO_REPRESENTATION_RULES } from './utils/representation-requirements.util';
import type { Props } from './types/props.type';

export const ActorForm = ({
  ValidationSchema,
  allowsInternalQuotationReceiver = false,
  askMemoBeforeSubmit = true,
  baseRoleFlags,
  categoryRestriction,
  excludedIds,
  formVariant,
  index,
  initialValues: pInitialValues,
  isInternal,
  onCancel: handleCancel,
  onSubmit: handleSubmit,
  representationRules = NO_REPRESENTATION_RULES,
  requiredRoleIds = EMPTY_ARRAY,
  selectionRestriction,
  setMustBlockAction,
  showCancelButton,
  stepIdsSubset,
  title,
}: Readonly<Props>) => {
  const { initialValues } = useInitialValuesFactory({
    index,
    initialValues: pInitialValues,
    isInternal,
  });

  const { isLoading, steps, wizardChildren } = useActorSteps({
    allowsInternalQuotationReceiver,
    categoryRestriction,
    excludedIds,
    initialValues,
    isInternal,
    representationRules,
    requiredRoleIds,
    selectionRestriction,
    stepIdsSubset,
  });

  return (
    <BaseRoleFlagsProvider value={baseRoleFlags}>
      {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-type-conversion */}
      {!!isLoading && <Loading />}
      <Wizard
        ValidationSchema={ValidationSchema}
        askMemoBeforeSubmit={askMemoBeforeSubmit}
        formTitle={title}
        formVariant={formVariant}
        initialValues={initialValues}
        onCancel={handleCancel}
        onSubmit={handleSubmit}
        setMustBlockAction={setMustBlockAction}
        showCancelButton={showCancelButton}
        steps={steps}
      >
        {wizardChildren}
      </Wizard>
    </BaseRoleFlagsProvider>
  );
};
